<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item label="患者问题搜索: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.message"
          placeholder="请输入"
          style="width: 250px"
          clearable
          size="mini"
        ></el-input>
      </el-form-item>

      <el-form-item label="患者手机号: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.phone"
          placeholder="请输入"
          style="width: 250px"
          clearable
          size="mini"
        ></el-input>
      </el-form-item>

      <el-form-item label="医生账号: " style="margin-left: 20px" v-if="roleId !== 3">
        <el-input
          v-model="selectForm.sup_username"
          placeholder="请输入"
          style="width: 250px"
          clearable
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="提问状态: ">
            <el-select v-model="selectForm.state" placeholder="请选择" clearable>
              <div v-for="item in doctorList" :key="item.id">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
      </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div class="tableBox">
      <ElTable
        height="calc(100vh - 220px)"
        :columns="listHeader"
        :tableData="dataList"
        :loading="loading"
        :total="listQuery.total"
        :listQuery="listQuery"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="message" slot-scope="{ row }">
          <el-popover trigger="hover" placement="top">
            <p style="text-align: center; max-width: 300px">
              <span style="color: rgb(59, 59, 59); font-weight: 600">{{ row.message }}</span>
            </p>
            <div
              slot="reference"
              class="name-wrapper addressDetail"
            >{{ row.message ? row.message : "-" }}</div>
          </el-popover>
        </template>

        <template slot="phone" slot-scope="{ row }">
          <span>{{ row.phone ? row.phone : "-" }}</span>
        </template>

        <template slot="money" slot-scope="{ row }">
          <span>{{ row.money ? row.money : "-" }}</span>
        </template>

        <template slot="sup_username" slot-scope="{ row }">
          <span>{{ row.sup_username ? row.sup_username : "暂无医生接单" }}</span>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <el-button size="mini" @click="detailsBtn(row)">详情及回复</el-button>
          <el-button size="mini" @click="handleOpen(row)">聊天内容总结</el-button>
        </template>
      </ElTable>
    </div>

    <!-- 产品提交表单 -->
    <el-dialog title="分配医生" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="患者提问" :label-width="formLabelWidth">
          <el-input v-model="form.message" auto-complete="off" disabled type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="医生列表: " style="margin-left: 20px">
          <el-select v-model="form.adminId" placeholder="请选择">
            <el-option
              v-for="item in doctorList"
              :label="item.message"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="检测结果(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.result"
            auto-complete="off"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情:回复,推荐用药,上传图片 -->
    <el-dialog
      title="详情"
      :visible.sync="detailsVisible"
      :close-on-click-modal="false"
      top="0"
      :fullscreen="true"
    >
      <h3>流水ID:{{ form.answerNumber }}</h3>
      <!-- 1.文字 2.选项 3.图片 4.推荐用药 -->
      <div class="box" ref="box">
        <div v-for="(item, index) in tableData" :key="index">
          <div class="person-one" v-if="item.userRole == 0">
            <div class="message">
              <div style="margin: 0px 0 10px">患者{{ item.phone }} ：</div>
              <div v-if="item.msgType == 3">
                <el-image
                  style="width: 60px; max-height: 60px"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                ></el-image>
              </div>
              <div v-if="item.msgType == 1">{{ item.message }}</div>
            </div>
            <div style="margin: 10px 0 0px">提问时间： {{ item.createTime }}</div>
          </div>
          <div class="person-two" v-else>
            <div class="message">
              <div style="margin: 0px 0 10px">{{ item.userRole == 1 ? "机器人 ：" : "医生 ：" }}</div>
              <!-- <div v-if="item.msgType == 1 && item.userRole === 2">
                {{ item.message }}
              </div>-->
              <!-- msgType, //1.文字 2.选项 3.图片 4.推荐用药 5综合问答 -->
              <div v-if="item.msgType == 1" style="font-size: 12px; margin: 10px 0 20px">
                <div v-if="typeof item.message.content === 'object'">
                  <div v-if="item.message.title">{{ item.message.title }}</div>
                  <p style="white-space: pre-line">{{ item.message.content[0] }}</p>
                </div>
                <div v-else>{{ item.message }}</div>
              </div>

              <div v-if="item.msgType == 3">
                <el-image
                  style="width: 60px; max-height: 60px"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                ></el-image>
              </div>

              <div v-if="item.msgType == 2">
                <div v-if="item.message.title">{{ item.message.title }}</div>
                <div v-for="(item, index) in item.message.content" :key="index">
                  <div style="font-size: 12px; margin: 10px 0 20px">
                    <p v-if="item.title">{{ item.title }}</p>
                    <p v-if="item.list">选项：{{ item.list }}</p>
                    <p v-if="item.answer">患者答案：{{ item.answer ? item.answer : "暂无回答" }}</p>
                    <div v-if="item.answerImg">
                      <el-image
                        style="width: 60px; max-height: 60px"
                        :src="item.answerImg"
                        :preview-src-list="[item.answerImg]"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.msgType == 4">
                <div v-for="(item, index) in item.message.content" :key="index">
                  <div style="font-size: 15px; margin: 10px 0 10px">{{ item.productName }}</div>
                </div>
              </div>

              <div v-if="item.msgType == 5">
                <div v-for="(items, index) in item.message" :key="index">
                  <div
                    v-if="items.type=='title' || items.type=='text' || items.type=='text' || items.type=='video'"
                  >{{ items.data }}</div>
                  <div
                    v-if="items.type=='pageLink'"
                  >{{ items.data.message }} =》 链接：{{ items.data.url }}</div>
                  <div v-if="items.type=='image'">
                    <el-image
                      style="width: 60px; max-height: 60px"
                      :src="item.answerImg"
                      :preview-src-list="[items.data]"
                    ></el-image>
                  </div>
                  <div v-if="items.type=='product'">
                    <div v-for="(j, index) in items.data" :key="index">
                      <div style="font-size: 15px; margin: 10px 0 10px">{{ j.productName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin: 10px 0 0px">时间：{{ item.createTime }}</div>
          </div>
        </div>
        <el-empty description="暂无聊天记录" v-if="tableData.length === 0"></el-empty>
      </div>
      <div class="btnList">
        <el-button type="primary" size="mini" @click="handleAdd">回复</el-button>
        <el-button size="mini" type="primary" @click="recommendBtn">推荐用药</el-button>
        <!-- 上传诊断书 -->
        <!-- <el-upload
          class="upload-demo"
          :action="action"
          :multiple="false"
          :on-success="handleSuccess_cover"
          :file-list="fileList"
          list-type="picture"
          name="formData"
          :limit="1"
        >
          <el-button type="primary" size="mini">上传诊断书</el-button>
        </el-upload>-->
        <el-button size="mini" type="primary" @click="handleOpen(form)">聊天内容总结</el-button>
        <el-button @click="detailsVisible = false" size="mini">关闭页面</el-button>
      </div>
    </el-dialog>

    <!-- 回复 -->
    <el-dialog title="回复患者" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label="内容" required>
          <el-input
            type="textarea"
            clearable
            v-model="dialogForm.message"
            :rows="5"
            maxlength="500"
            show-word-limit
            placeholder="医生每次回复都可以勾选发送短信按钮，给患者发送短信提醒。请组织语言集中回复,减少短信推送频率,谢谢配合！"
          ></el-input>
        </el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="hanldeAiRead"
          style="margin:0 120px 20px"
          :loading="loading_messageAi"
        >ai优化回复内容</el-button>
        <el-form-item label="Ai优化后的内容">
          <el-input
            type="textarea"
            clearable
            v-model="dialogForm.messageAi"
            :rows="5"
            maxlength="500"
            show-word-limit
            placeholder="医生每次回复都可以勾选发送短信按钮，给患者发送短信提醒。请组织语言集中回复,减少短信推送频率,谢谢配合！"
          ></el-input>
        </el-form-item>

        <el-form-item label>
          <el-checkbox v-model="dialogForm.checked">回复后是否发送短信(通知患者)</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确定回复</el-button>
      </div>
    </el-dialog>

    <!-- 推荐用药 -->
    <el-dialog title="推荐用药" :visible.sync="recommendVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="选择用药" required>
          <el-select
            v-model="dialogForm.goods"
            multiple
            filterable
            placeholder="请输入关键词搜索商品"
            style="width: 100%"
          >
            <el-option
              v-for="item in goodsArr"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-checkbox v-model="dialogForm.checked">发送短信</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="recommendVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer title="聊天内容总结" :visible.sync="visible_drawer">
      <div class="visible_drawer">
        <div>流水ID：{{form.answerNumber}}</div>
        <div>患者姓名：{{form.name}}</div>
        <div>患者手机号：{{form.phone}}</div>
        <div>患者问题：{{form.message}}</div>

        <div>
          <el-button type="primary" @click="handleTransform" :loading="loading_messageAi">AI总结</el-button>
        </div>
        <div class="scrollable-div">
          <pre>{{message_count}}</pre>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import { selectGoods } from "@/services/mall/goods";
import {
  selectRecordList,
  selectRecordDetails,
  deleteRecord,
  updateRecord,
  addRecord,
  send
} from "@/services/answers/record.js";
import { ai_api, selectApi, addApi } from "@/services/ai/index.js";
import { selectspuser } from "@/services/system/admin.js";
import { IP } from "@/services/index.js";
export default {
  components: {
    ElTable
  },
  data() {
    return {
      action: IP + "/uploadFile/add",
      goodsArr: [],
      roleId: "",
      selectForm: {},
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: ""
      },
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      isRole: false,
      //1待邮寄 2已邮寄 3已送检 4检测完成
      doctorList: [],
      formLabelWidth: "100px",
      detailsVisible: false,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        messageAi: "",
        message: "",
        checked: false
      },
      loading_messageAi: false,
      recommendVisible: false,
      fileList: [],

      visible_drawer: false,
      message_count: "",
      listHeader: [
        { label: "序号", type: "index", width: "50", align: "center" },
        {
          label: "流水ID",
          prop: "answerNumber",
          width: "150",
          align: "center"
        },
        {
          label: "患者提问",
          slots: "message",
          width: "250",
          align: "center"
        },
        { label: "患者手机号", slots: "phone", width: "150", align: "center" },
        { label: "付费金额", slots: "money", width: "150", align: "center" },
        {
          label: "所属医生账号",
          slots: "sup_username",
          width: "130",
          align: "center"
        },
        {
          label: "提问时间",
          prop: "createTime",
          width: "200",
          align: "center"
        },
        {
          label: "操作",
          slots: "operation",
          width: "250",
          align: "center",
          fixed: "right"
        }
      ]
    };
  },
  async created() {
    let result = await selectspuser({ roleId: 3 });
    this.doctorList = result;
    if (this.$store.state.supUser.roleId == 3) {
      this.selectForm.adminId = this.$store.state.supUser.id;
      this.roleId = 3;
    }
    this.select();
    this.selectAll();
  },
  methods: {
    /* 打开ai弹窗 */
    async handleOpen(row) {
      this.message_count = "";
      this.visible_drawer = true;
      this.form = JSON.parse(JSON.stringify(row));
      let result = await selectApi({ answerNumber: row.answerNumber });
      if (result.code == 200 && result.data.length > 0) {
        this.message_count = result.data[0].content;
      }
    },
    /* ai总结患者内容 type:1-患者,2-医生 */
    async handleTransform() {
      this.loading_messageAi = true;
      let result_record = await selectRecordDetails({
        answerNumber: this.form.answerNumber
      });

      const result = await ai_api({
        message: JSON.stringify(result_record.data),
        type: 1
      });
      console.log("result", result.data.choices[0].message.content);
      this.loading_messageAi = false;
      try {
        if (result.code == 200) {
          this.message_count = result.data.choices[0].message.content;
          await addApi({
            answerNumber: this.form.answerNumber,
            content: result.data.choices[0].message.content
          });
        }
      } catch (error) {}
    },
    /* ai优化 type:1-患者,2-医生 */
    async hanldeAiRead() {
      this.loading_messageAi = true;
      const result = await ai_api({
        message: this.dialogForm.message,
        type: 2
      });
      console.log("result", result.data.choices[0].message.content);
      this.loading_messageAi = false;
      try {
        if (result.code == 200) {
          this.dialogForm.messageAi = result.data.choices[0].message.content;
        }
      } catch (error) {}
    },

    detailsApi(answerNumber) {
      selectRecordDetails({ answerNumber }).then(res => {
        this.tableData = res.data.map(item => {
          if (
            item.msgType == 2 ||
            item.msgType == 4 ||
            item.msgType == 5 ||
            ((item.userRole === 1 || item.userRole === 2) && item.msgType == 1)
          ) {
            try {
              item.message = JSON.parse(item.message);
            } catch (e) {
              item.message = item.message;
            }
          }
          return item;
        });

        this.dialogForm.message = "";
        this.dialogForm.messageAi = "";
        this.dialogVisible = false;
        this.recommendVisible = false;
        setTimeout(() => {
          this.$refs.box.scrollTop = this.$refs.box.scrollHeight;
        }, 300);
      });
    },

    /* 详情 */
    detailsBtn(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.detailsApi(row.answerNumber);
      this.detailsVisible = true;
    },

    /* 回复消息弹窗*/
    handleAdd() {
      this.dialogVisible = true;
    },

    /* 回复图片 */
    async handleSuccess_cover(e) {
      let msgType = 3;
      let message = e.data;
      const addResult = await addRecord({
        phoneAnswer: this.$store.state.supUser.supplier_phone,
        userId: this.form.userId,
        adminId: this.$store.state.supUser.id,
        phone: this.form.phone,
        answerNumber: this.form.answerNumber,
        diseaseType: this.form.diseaseType,
        userRole: 2,
        answerIndex: 1,
        message,
        msgType
      });
      if (addResult.code !== 200) {
        this.$message.error("发送失败");
        return;
      }
      this.detailsApi(this.form.answerNumber);
      this.fileList = [];
    },

    /* 回复消息 */
    async save() {
      // console.log(this.dialogForm);
      //必填字段校验
      if (!this.dialogForm.message && this.dialogVisible) {
        this.$message.error("请填写必填字段");
        return;
      }
      if (
        this.recommendVisible &&
        (!this.dialogForm.goods || this.dialogForm.goods.length == 0)
      ) {
        this.$message.error("请选择推荐药品");
        return;
      }

      let msgType = 1; //回复文字
      let message = JSON.stringify({
        title: "医生诊断结果",
        content: [
          this.dialogForm.messageAi
            ? this.dialogForm.messageAi
            : this.dialogForm.message
        ]
      });

      if (this.recommendVisible) {
        let content = this.dialogForm.goods.map(i => {
          let item = this.goodsArr.find(item1 => i == item1.id);
          return {
            coverImg: item.coverImg,
            productName: item.productName,
            id: item.id,
            price: item.price,
            adminId: this.$store.state.supUser.id,
            discountPrice: item.discountPrice,
            freight: item.freight,
            status: item.status
          };
        });
        msgType = 4; //回复用药
        message = {
          title: "医生推荐商品",
          content
        };
      }

      const addResult = await addRecord({
        phoneAnswer: this.$store.state.supUser.supplier_phone,
        userId: this.form.userId,
        adminId: this.$store.state.supUser.id,
        phone: this.form.phone,
        answerNumber: this.form.answerNumber,
        diseaseType: this.form.diseaseType,
        userRole: 2,
        answerIndex: 1,
        message,
        msgType
      });

      if (addResult.code !== 200) {
        this.$message.error("发送失败");
        return;
      }
      this.detailsApi(this.form.answerNumber);
      if (this.dialogForm.checked) {
        //发送短信
        send({ phone: this.form.phone }).then(res => {
          console.log("发送短信===========", res);
          this.dialogForm.checked = false;
        });
      }
    },

    /* 推荐用药 */
    recommendBtn() {
      this.recommendVisible = true;
      // this.dialogForm.goods = [];
    },

    /* 查询提问数据 */
    select() {
      this.loading = true;
      selectRecordList({
        ...this.selectForm,
        adminId: this.$store.state.supUser.id,
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize
      }).then(resp => {
        this.dataList = resp.data || [];
        this.listQuery.total = resp.count || 0;
        this.loading = false;
      });
    },

    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.select();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.listQuery.pageNumber = 1;
      this.select();
    },

    /* 查询商品数据 */
    selectAll() {
      selectGoods({
        id: "",
        productName: ""
      }).then(resp => {
        this.goodsArr = resp.data;
      });
    },

    selectBtn() {
      this.select();
    },

    // 确认修改
    updataLogisticsNumberBtn() {
      // if (this.form.logisticsNumber == "") {
      //   this.$message.error("请填写物流单号");
      //   return;
      // }
    },
    // 提交表单按钮
    updateBtn() {
      // console.log("点击了确认", this.form);
      updateRecord({
        ...this.form,
        phoneAnswer: this.$store.state.supUser.supplier_phone
      }).then(resp => {
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogFormVisible = false;
          this.select();
        }
      });
    },

    deleteBtn(row) {
      this.$confirm("此操作将永久删除该提问, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteRecord({ answerNumber: row.answerNumber }).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then(excel => {
        const tHeader = [
          "id",
          "提问号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "提问总价",
          "物流单号",
          "提问状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "提问时间"
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "state",
          "productList",
          "createTime"
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map(item => {
          const product = item.productList.map(item2 => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(",")
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "提问列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.content {
  margin: 10px auto;
  width: 98%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.addressDetail:hover {
  cursor: pointer;
}

.addressDetail {
  width: 140px;
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

h3 {
  margin: 0 0 20px;
  font-size: 16px;
}

.box {
  padding: 20px;
  margin: 0 auto;
  width: 95%;
  height: calc(100vh - 250px);
  overflow-y: auto;
  line-height: 26px;
}

.message {
  color: 111;
  font-size: 16px;
}

.person-one {
  background: rgba(230, 230, 230, 1);
  padding: 20px 30px;
  border-radius: 20px;
  margin: 10px 0;
}

.person-two {
  background: rgb(255, 255, 255);
  border: 1px solid rgba(230, 230, 230, 1);
  padding: 20px 30px;
  border-radius: 20px;
  margin: 10px 0;
}

.btnList {
  display: flex;
  margin: 20px auto;
  justify-content: center;
  button {
    margin: 0 10px;
    height: 30px;
  }
}

.visible_drawer {
  width: 100%;
}
.visible_drawer > div {
  margin: 20px;
}
.scrollable-div {
  // width: 100%; /* 设置你想要的宽度 */
  max-height: 500px; /* 设置你想要的高度 */
  overflow: auto; /* 添加滚动条 */
}
</style>
